import { Routes } from '@angular/router';

import { LoginComponent } from './autorizare/login/login.component';
import { Error404Component } from './core/error404/error404.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NavigationComponent } from './navigation/navigation.component';
import { AppConfig } from './shared/config/app.config';
import { authGuard, isAdminGuard } from './shared/services/auth.guard';

export const routes: Routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    { path: '', component: DashboardComponent, canActivate: [authGuard] },
    {
        path: '',
        component: NavigationComponent,
        canActivate: [authGuard],
        children: [
            { path: 'dashboard', component: DashboardComponent },
            {
                path: 'medic',
                loadChildren: () => import('./medic/medic.routes').then(m => m.MEDIC_ROUTES),
            },
            {
                path: 'admin',
                loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES),
                canActivate: [isAdminGuard],
            },
            {
                path: 'cmj',
                loadChildren: () => import('./cmj/cmj.routes').then(m => m.CMJ_ROUTES),
            },
            {
                path: 'avizari-cmr',
                loadChildren: () => import('./avizari-cmr/avizari-cmr.routes').then(m => m.AVIZARI_CMR_ROUTES),
            },
        ],
    },
    { path: 'autorizare', component: LoginComponent },
    { path: AppConfig.routes.error404, component: Error404Component },
    { path: '**', redirectTo: '/' + AppConfig.routes.error404 },
];
